import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "xwxq-wrapper"
};
const _hoisted_2 = {
  class: "xwxq-page"
};
const _hoisted_3 = {
  key: 0,
  class: "loading-wrapper"
};
const _hoisted_4 = {
  key: 1,
  class: "detail-content"
};
const _hoisted_5 = {
  class: "news-title"
};
const _hoisted_6 = {
  key: 0,
  class: "news-subtitle"
};
const _hoisted_7 = {
  class: "news-meta"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  key: 2,
  class: "news-attachment"
};
const _hoisted_11 = ["href"];
const _hoisted_12 = {
  class: "back-btn-wrapper"
};
const _hoisted_13 = {
  key: 2,
  class: "empty-wrapper"
};
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getArticleById } from '@/api/news';
export default /*@__PURE__*/_defineComponent({
  __name: 'Xwxq',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const newsDetail = ref(null);
    const loading = ref(true);
    const fetchNewsDetail = async id => {
      try {
        loading.value = true;
        const res = await getArticleById(id);
        if (res.data) {
          newsDetail.value = res.data;
        }
      } catch (error) {
        console.error('获取新闻详情失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const goBack = () => {
      router.go(-1);
    };
    const formatDate = dateStr => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    onMounted(() => {
      const id = route.params.id;
      if (id) {
        fetchNewsDetail(Number(id));
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "loading-text"
      }, "加载中...", -1)]))])) : newsDetail.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(newsDetail.value.title), 1), newsDetail.value.subtitle ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(newsDetail.value.subtitle), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [newsDetail.value.author ? (_openBlock(), _createElementBlock("span", _hoisted_8, "作者：" + _toDisplayString(newsDetail.value.author), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, "发布时间：" + _toDisplayString(formatDate(newsDetail.value.publishTime)), 1)]), newsDetail.value.content ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        innerHTML: newsDetail.value.content,
        class: "news-content"
      }, null, 8, _hoisted_9)) : _createCommentVNode("", true), newsDetail.value.attachment ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "attachment-title"
      }, "附件下载", -1)), _createElementVNode("a", {
        href: newsDetail.value.attachment,
        target: "_blank",
        class: "attachment-link"
      }, "点击下载附件", 8, _hoisted_11)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
        onClick: goBack
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("返回列表", -1)]))]),
        _: 1
      })])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
        class: "empty-text"
      }, "暂无新闻详情", -1)]))]))]), _createVNode(_component_Footer)]);
    };
  }
});